export const ItemsFilteredIcon = () => {
  return (
    <svg
      width="127"
      height="114"
      viewBox="0 0 127 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>No Items Match Filters</title>
      <g clipPath="url(#clip0_4855_13168)">
        <path
          d="M0 113.97C0 86.0604 22.5357 63.4375 50.3375 63.4375C78.1392 63.4375 100.675 86.0604 100.675 113.97"
          fill="#9563FF"
        />
        <path d="M44.4561 18.0211L127 0V36.6857L44.4561 18.0211Z" fill="#FFF543" />
        <path d="M75.3245 114.001H27.4072L36.2985 28.6055H66.4333L75.3245 114.001Z" fill="white" />
        <mask
          id="mask0_4855_13168"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="27"
          y="28"
          width="49"
          height="86"
        >
          <path
            d="M75.3245 114.001H27.4072L36.2985 28.6055H66.4333L75.3245 114.001Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_4855_13168)">
          <path
            d="M23.0381 56.1172H79.3287"
            stroke="#F54D42"
            strokeWidth="22.28"
            strokeMiterlimit="10"
          />
          <path
            d="M23.0381 87.5625H79.3287"
            stroke="#F54D42"
            strokeWidth="22.28"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M48.1025 8.18359H54.635C57.6449 8.18359 60.0908 10.6389 60.0908 13.6605V25.6951H42.6416V13.6605C42.6416 10.6389 45.0875 8.18359 48.0974 8.18359H48.1025Z"
          fill="#242424"
        />
        <path
          d="M29.5557 29.2305H73.176"
          stroke="#242424"
          strokeWidth="16.34"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_4855_13168">
          <rect width="127" height="114" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
